import axios from "axios";
import { API_endpoints } from "./API_Endpoints";
import { NavRoutes } from "../Component/Navbar/NavRoutes";

const Axios = axios.create({
  baseURL: API_endpoints.baseURL,
});

const handleLogOut = () => {
  try {
    localStorage.removeItem("Fiesta");
    localStorage.removeItem("Fiesta_compID");
    localStorage.removeItem("fiesta_subscription_details");
    window.location.href = NavRoutes.LOGIN;
  } catch (error) {
    console.error("Error handling i18next storage event:", error);
  }
};

export const API_POST = async (url, data) => {
  let apikey;
  let token;
  let parsedData = JSON.parse(localStorage.getItem("Fiesta"));
  if (parsedData) {
    apikey = parsedData?.apikey;
    token = parsedData?.token;
  }
  let uri;
  if (token && apikey) {
    uri = url + "?token=" + token + "&apikey=" + apikey;
  } else {
    uri = url;
  }

  try {
    const res = await Axios.post(uri, data, {
      headers: null,
    });
    return res.data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};

export const API_POST2 = async (url, data) => {
  let apikey;
  let token;
  let parsedData = JSON.parse(localStorage.getItem("Fiesta"));
  if (parsedData) {
    apikey = parsedData?.apikey;
    token = parsedData?.token;
  }
  let uri;
  if (token && apikey) {
    uri = url + "&token=" + token + "&apikey=" + apikey;
  } else {
    uri = url;
  }
  try {
    const res = await Axios.post(uri, data, {
      headers: null,
    });

    return res.data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};

export const API_GET = async (url) => {
  try {
    let apikey;
    let token;
    let parsedData = JSON.parse(localStorage.getItem("Fiesta"));
    if (parsedData) {
      apikey = parsedData?.apikey;
      token = parsedData?.token;
    }
    let uri;
    if (token && apikey) {
      uri = url + "?token=" + token + "&apikey=" + apikey;
    } else {
      uri = url;
    }

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
export const API_GET2 = async (url) => {
  try {
    let apikey;
    let token;
    let parsedData = JSON.parse(localStorage.getItem("Fiesta"));
    if (parsedData) {
      apikey = parsedData?.apikey;
      token = parsedData?.token;
    }
    let uri;
    if (token && apikey) {
      uri = url + "&token=" + token + "&apikey=" + apikey;
    } else {
      uri = url;
    }

    const { data } = await Axios.get(uri, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
export const API_GET_OPEN = async (url) => {
  try {
    const { data } = await Axios.get(url, {
      headers: null,
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
export const API_GET_USERID = async (url, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("Fiesta")).token;
    const apikey = JSON.parse(localStorage.getItem("Fiesta")).apikey;

    const { data } = await Axios.get(url, {
      params: {
        user_id: id,
        token: token,
        apikey: apikey,
      },
      headers: {
        // Add any headers you need here
      },
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
export const API_GET_USERID_WITH_LOGIN = async (url, id, tkn, key) => {
  try {
    const token = tkn;
    const apikey = key;

    const { data } = await Axios.get(url, {
      params: {
        user_id: id,
        token: token,
        apikey: apikey,
      },
      headers: {
        // Add any headers you need here
      },
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
export const API_GET_ID = async (url, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("Fiesta")).token;
    const apikey = JSON.parse(localStorage.getItem("Fiesta")).apikey;

    const { data } = await Axios.get(url, {
      params: {
        id: id,
        token: token,
        apikey: apikey,
      },
      headers: {
        // Add any headers you need here
      },
    });

    return data;
  } catch (error) {
    if (error.status === 401) {
      handleLogOut();
    } else {
      return error;
    }
  }
};
